import React from "react";
import Icon from "../Icon";
import { Button, Pill, Spinner } from "../primitives";

/**
 * Apply / Applied (tap asks to withdraw) / Joined / inactive, from joinStateFor(). `testId` lands on the
 * tappable button. The list card and the club page both render this, so Applied looks the same in both.
 */
export default function JoinButton({ state, busy = false, onPress, size = "xs", testId }) {
  if (state === "joined") return <Pill tone="green" icon="check">Joined</Pill>;
  if (state === "inactive") return <Pill tone="gray">Not active</Pill>;
  if (busy) return <span className={`btn sec ${size} cl-joinbtn`} aria-busy="true"><Spinner label="Working" /></span>;
  if (state === "applied") {
    return (
      <Button variant="sec" size={size} className="cl-joinbtn" onClick={onPress} data-testid={testId} title="Withdraw application" aria-label="Applied. Withdraw application">
        Applied <Icon name="x" size={size ? 12 : 14} />
      </Button>
    );
  }
  return <Button size={size} className="cl-joinbtn" onClick={onPress} data-testid={testId}>Apply</Button>;
}
